var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":"资源地址："}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":"请输入url地址"},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }